import React from "react"
import { View, StyleSheet, Dimensions, Image } from "react-native"
import { ActivityIndicator } from "react-native-paper"
import { baseColors, dimensions } from "@Constants/baseStyles"
import { StatusBar } from "expo-status-bar"
import splash_soignant from "@assets/splash_soignant.png"
import splash_cpts from "@assets/splash_cpts.png"
import Constants from "expo-constants"

const { platform } = Constants.expoConfig.extra
const isCpts = platform === "cpts"

const { height } = Dimensions.get("screen")

export const LoadingPage = ({}) => {
    const splashImg = !isCpts ? splash_soignant : splash_cpts

    return (
        <View style={{ flex: 1, backgroundColor: baseColors.green.primary, height: height }}>
            <StatusBar translucent />
            <Image
                style={{
                    height: height,
                    width: dimensions.fullWidth
                }}
                resizeMode="cover"
                source={splashImg}
                defaultSource={splashImg}
            />
            {/* <View style={{ flexDirection: "row", alignItems: "center", justifyContent: "center", alignSelf: "center" }}>
                <ActivityIndicator animating color="white" />
            </View> */}
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        paddingTop: 20,
        paddingHorizontal: 20,
        backgroundColor: "white",
        alignContent: "center"
    },
    text: {
        color: baseColors.black,
        textAlign: "justify",
        fontFamily: "BreeSerif",
        fontSize: 16
    }
})
